import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { callAPI } from "../feature/APISlice";
import { openForm } from "../feature/formSlice";
import AdminNavbar from "./AdminNavbar";
import InitiativeForm from "../Form/InitiativeForm";

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/initiatives`;

export default function InitiativeList() {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((s) => s.api);

  useEffect(() => {
    dispatch(callAPI({ method: "get", url: BASE_URL }));
  }, [dispatch]);

  return (
    <div>
      <AdminNavbar />

      <div className="customcontainer">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <button
            className="admin-btn outline"
            onClick={() => dispatch(openForm(null))}
          >
            + Add Initiative
          </button>
        </div>

        {loading && <p>Loading...</p>}
        {error && <p className="error-text">{error}</p>}

        <div className="admin-card-grid">
          {items.length > 0 ? (
            items.map((i) => (
              <div className="admin-card" key={i.id}>
                <div className="admin-card-header">
                  <h4 className="admin-card-title">
                    {i.title || "No Title"}
                  </h4>
                </div>

                <p className="admin-card-status">
                  Status: {i.is_active ? " Active" : "❌ Inactive"}
                </p>

                <div className="admin-card-info">
                  <p>
                    Created By:{" "}
                    <strong>{i.createdByName || "Unknown"}</strong>
                  </p>
                  <p>
                    Updated By:{" "}
                    <strong>
                      {i.lastModifiedByName || "Unknown"}
                    </strong>
                  </p>
                </div>

                <div className="admin-card-actions">
                  <button
                    className="admin-card-btn"
                    onClick={() => dispatch(openForm(i.id))}
                  >
                    ✏️
                  </button>
                  <button
                    className="admin-card-btn"
                    onClick={() =>
                      window.confirm("Delete this initiative?") &&
                      dispatch(
                        callAPI({
                          method: "delete",
                          url: `${BASE_URL}/${i.id}`,
                          data: { id: i.id },
                        })
                      )
                    }
                  >
                    🗑️
                  </button>
                </div>
              </div>
            ))
          ) : (
            !loading && <p>No initiatives found.</p>
          )}
        </div>
      </div>

      <InitiativeForm />
    </div>
  );
}
